import React from 'react';
import { Mail, MessageCircle, MapPin, Linkedin, Facebook, Instagram } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const top = element.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  const links = [
    { id: 'home', label: t.nav.home },
    { id: 'about', label: t.nav.about },
    { id: 'products', label: t.nav.products },
    { id: 'services', label: t.nav.services },
    { id: 'faq', label: t.nav.faq },
    { id: 'contact', label: t.nav.contact }
  ];

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-purple-900 to-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-1.5">
              <div className="w-10 h-10 flex-shrink-0">
                <img
                  src="/images/plbvvz5z_C3.png"
                  alt="Arrigo IOT Logo"
                  className="w-full h-full object-contain"
                />
              </div>
              <img src="/images/Q3.png" alt="Q3" className="h-8 w-auto flex-shrink-0 object-contain" />
            </div>
            <p className="text-sm text-gray-300 leading-relaxed">
              {t.footer.description}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">{t.footer.quickLinks}</h3>
            <ul className="space-y-2">
              {links.map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollToSection(link.id)}
                    className="text-sm text-gray-300 hover:text-purple-400 transition-colors text-left"
                    data-testid={`footer-link-${link.id}`}
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">{t.footer.contact}</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-purple-400 mt-0.5 flex-shrink-0" />
                <a href="mailto:sales@arrigo-aiot.com" className="text-sm text-gray-300 hover:text-purple-400 transition-colors break-all">
                  sales@arrigo-aiot.com
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <MessageCircle className="w-5 h-5 text-purple-400 mt-0.5 flex-shrink-0" />
                <a
                  onClick={() => window.open("https://wa.me/6285226698558?text=Hi%20Arrigo%20IOT%2C%20I%20want%20to%20ask%20about%20/%20Saya%20ingin%20bertanya%20tentang...", "_blank", "noopener,noreferrer")}
                  role="button"
                  tabIndex={0}
                  className="text-sm text-gray-300 hover:text-purple-400 transition-colors cursor-pointer"
                >
                  Chat on WhatsApp
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-purple-400 mt-0.5 flex-shrink-0" />
                <span className="text-sm text-gray-300">
                  Jl. Raya Tapos No. 57<br />
                  Kec. Tapos, Kota Depok<br />
                  Jawa Barat, Indonesia
                </span>
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div>
            <h3 className="text-lg font-semibold mb-4">{t.footer.followUs}</h3>
            <div className="flex space-x-3">
              <a
                href="#"
                className="w-10 h-10 rounded-lg bg-white/10 hover:bg-purple-600 flex items-center justify-center transition-all hover:scale-110"
                aria-label="LinkedIn"
                data-testid="social-linkedin"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-lg bg-white/10 hover:bg-purple-600 flex items-center justify-center transition-all hover:scale-110"
                aria-label="Facebook"
                data-testid="social-facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-lg bg-white/10 hover:bg-purple-600 flex items-center justify-center transition-all hover:scale-110"
                aria-label="Instagram"
                data-testid="social-instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-700">
          <p className="text-center text-sm text-gray-400">
            © {currentYear} PT. Arrigo Inti Otomasi Teknologi. {t.footer.rights}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
